import React from 'react';
import Table from '../../components/table';
import { TableUser, SortConfig, TableColumn } from './types';
import { UserManagementSkeleton } from '../../components/Skeleton';

interface UserTableProps {
    users: TableUser[];
    columns: TableColumn[];
    totalItems: number;
    currentPage: number;
    pageSize: number;
    loading: boolean;
    sortConfig: SortConfig;
    onPageChange: (page: number) => void;
    onSearch: (searchTerm: string) => void;
    onRowClick: (item: TableUser) => void;
    onStatusChange: (userId: string, newStatus: string) => void;
    onSort: (key: string, direction: 'asc' | 'desc' | null) => void;
}

const UserTable: React.FC<UserTableProps> = ({
    users,
    columns,
    totalItems,
    currentPage,
    pageSize,
    loading,
    sortConfig,
    onPageChange,
    onSearch,
    onRowClick,
    onStatusChange,
    onSort
}) => {
    if (loading) {
        return <UserManagementSkeleton />;
    }

    if (users.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-12 px-4">
                <svg className="w-12 h-12 text-text-secondary mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <h3 className="text-subtext font-medium text-text-primary mb-1">No Users Found</h3>
                <p className="text-small text-text-secondary">No users match your search criteria</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <Table
                testId="users-table"
                columns={columns}
                data={users}
                totalItems={totalItems}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={onPageChange}
                searchable={true}
                onSearch={onSearch}
                onRowClick={onRowClick}
                onStatusChange={onStatusChange}
                onSort={onSort}
                sortConfig={sortConfig}
            />
        </div>
    );
};

export default UserTable;
